import { Card } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import type { ReactElement } from 'react';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface NetworkHealthCardProps {
  children: ReactElement[] | ReactElement;
}

export function NetworkHealthCard({ children }: NetworkHealthCardProps) {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Card
      sx={{
        backgroundColor: palette.boxBackground,
        textAlign: 'center',
        color: palette.textPrimary,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid ${
          enableDarkTheme ? palette.borderGrey : palette.border
        }`,
        borderRadius: '8px',
        height: '100%',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      {children}
    </Card>
  );
}

export default NetworkHealthCard;
